export default __webpack_public_path__ + "static/media/chat.ce2c20c8.svg";